export default "__VITE_ASSET__B3tzc$cd__"